<ion-card class="card-common-blue ion-no-margin ">
  <!-- Card header with title and icon -->
  <ion-card-header>
    <ion-card-title>
      <div class="d-flex align-items-center gap-2">
        <ion-icon size="small" src="assets/icon/unrectify-defect.svg" class="svgIcon">
        </ion-icon>

        <span>
          {{ 'UNRECTIFIED_MSG' | translate }}
        </span>
      </div>
    </ion-card-title>
  </ion-card-header>

  <!-- Card content -->
  <ion-card-content [class]="isMobileApp() ? 'ion-no-padding' : ''">
    <!-- Web view layout -->
    @if (!isMobileApp()) {
    @if (unrectifiedDefects().length > 0) {
    <ion-grid class="ion-margin-top commonGrid">
      <!-- Grid header -->
      <ion-row class="gridHead">
        <ion-col size="2">
          {{ 'D_LABEL13' | translate }}
        </ion-col>
        <ion-col size="1.5">
          {{ 'PRE_USE_LABEL13' | translate }}
        </ion-col>
        <ion-col size="1.5">
          {{ 'PRE_USE_LABEL14' | translate }}
        </ion-col>
        <ion-col size="2">
          {{ 'PRE_USE_LABEL18' | translate }}
        </ion-col>
        <ion-col size="4">
          {{ 'PRE_USE_LABEL20' | translate }}
        </ion-col>
        <ion-col size="1" class="text-center">
          {{ 'PRE_USE_LABEL21' | translate }}
        </ion-col>
      </ion-row>

      <!-- Grid data rows -->
      @for (details of unrectifiedDefects(); track $index) {
      <ion-row class="gridData">
        <ion-col size="2">
          {{ details.inspectioN_REPORT_DATE | formatDate:isMobileApp() }}
        </ion-col>

        <ion-col size="1.5">
          {{ details.shorT_INSPECTION_ID }}
        </ion-col>

        <ion-col size="1.5">
          {{ details.shorT_DEFECT_ID }}
        </ion-col>

        <ion-col size="2" class="safetyType-col-web"
          [ngClass]="{
            'ion-align-items-center': !checkHasMedia(details.haS_MEDIA),
            'has-media-padding': checkHasMedia(details.haS_MEDIA)
          }">
          <ng-container *ngTemplateOutlet="safetyTypeTpl; context: { $implicit: details }">
          </ng-container>
        </ion-col>

        <ion-col size="4">
          {{ details.iteM_DESCRIPTION }}
        </ion-col>

        <ion-col size="1" class="text-center">
          @if (checkHasMedia(details.haS_MEDIA)) {
          <ion-icon class="media-icon" src="assets/icon/defect-media.svg"
            (click)="showDefectMedia(details.veH_INSPECT_RPT_DTL_ID)"
            (keydown.enter)="showDefectMedia(details.veH_INSPECT_RPT_DTL_ID)">
          </ion-icon>
          }
          @else {
          <ng-container *ngTemplateOutlet="noMediaTpl"></ng-container>
          }
        </ion-col>
      </ion-row>
      }
    </ion-grid>
    }
    @else {
    <ng-container *ngTemplateOutlet="noDataTpl; context: { $implicit: 'UNROADWORTHY_VALIDATION' }">
    </ng-container>
    }
    }

    <!-- Mobile view layout -->
    @else {
    @if (unrectifiedDefectsMobile.length > 0) {
    @for (defect of unrectifiedDefectsMobile; track $index) {
    @for (details of defect.defects; let i = $index; track $index) {
    <ion-item-divider class="ion-padding bg-white color-primary">
      <div class="unrectified-defects-mobile w-100">
        <!-- Mobile header -->
        @if (i === 0) {
        <div class="header d-flex justify-content-between w-100 align-items-center">
          <div class="date-section">
            {{ defect.inspectioN_REPORT_DATE | formatDate:isMobileApp() }}
          </div>
          <div class="id-section fw-normal">
            {{ 'PRE_USE_LABEL13' | translate }} :
            {{ defect.shorT_INSPECTION_ID }}
          </div>
        </div>
        }

        <!-- Mobile defect details -->
        <div class="fw-normal" [ngClass]="i === 0 ? 'ion-padding-top' : ''">
          <ion-grid class="ion-no-padding">
            <ion-row class="ion-no-padding">
              <ion-col size="10" class="ion-no-padding defects-details">
                <ion-row class="mb-2">
                  <ion-col size="4" class="ion-no-padding">
                    {{ 'PRE_USE_LABEL14' | translate }} :
                  </ion-col>
                  <ion-col size="8" class="ion-no-padding">
                    {{ details.shorT_DEFECT_ID }}
                  </ion-col>
                </ion-row>

                <ion-row class="mb-2">
                  <ion-col size="4" class="ion-no-padding">
                    {{ 'PRE_USE_LABEL18' | translate }} :
                  </ion-col>
                  <ion-col size="8" class="ion-no-padding d-flex align-items-center">
                    <ng-container *ngTemplateOutlet="safetyTypeTpl; context: { $implicit: details }">
                    </ng-container>
                  </ion-col>
                </ion-row>

                <ion-row class="mb-2">
                  <ion-col size="4" class="ion-no-padding">
                    {{ 'PRE_USE_LABEL20' | translate }} :
                  </ion-col>
                  <ion-col size="8" class="ion-no-padding">
                    {{ details.iteM_DESCRIPTION }}
                  </ion-col>
                </ion-row>

                <ion-row class="mb-2">
                  <ion-col size="4" class="ion-no-padding">
                    {{ 'PRE_USE_LABEL23' | translate }} :
                  </ion-col>
                  <ion-col size="8" class="ion-no-padding">
                    {{ details.defecT_COMMENT }}
                  </ion-col>
                </ion-row>
              </ion-col>

              <!-- Media icon -->
              @if (checkHasMedia(details.haS_MEDIA)) {
              <ion-col size="2" class="ion-no-padding d-flex justify-content-end"
                (click)="showDefectMedia(details.veH_INSPECT_RPT_DTL_ID)"
                (keydown.enter)="showDefectMedia(details.veH_INSPECT_RPT_DTL_ID)">
                <ion-icon size="large" src="assets/icon/defect-media.svg">
                </ion-icon>
              </ion-col>
              }
            </ion-row>
          </ion-grid>
        </div>
      </div>
    </ion-item-divider>
    }
    }
    }
    @else {
    <ng-container *ngTemplateOutlet="noDataTpl; context: { $implicit: 'UNROADWORTHY_VALIDATION' }">
    </ng-container>
    }
    }
  </ion-card-content>
</ion-card>

<!-- Safety type template -->
<ng-template #safetyTypeTpl let-details>
  @if (!checkSafetyInd(details.safetY_IMPACT_IND)) {
  <ion-text class="d-inline-flex defect-text">
    <ion-icon src="assets/icon/warning-outline-orange.svg"></ion-icon>
    <span class="defect-txt ms-1">Defect</span>
  </ion-text>
  }
  @else {
  <ion-text class="safetydefect-text d-inline-flex">
    <ion-icon src="assets/icon/warning-outline.svg"></ion-icon>
    <span class="defect-txt ms-1">Safety Defect</span>
  </ion-text>
  }
</ng-template>

<!-- No media placeholder -->
<ng-template #noMediaTpl>
  -
</ng-template>

<!-- No data / empty state template -->
<ng-template #noDataTpl let-message>
  <ion-row class="ion-margin-top" [ngClass]="{'ion-margin-bottom':isMobileApp()}">
    <ion-col size="12" class="ion-text-center d-flex justify-content-center">
      {{ message | translate }}
    </ion-col>
  </ion-row>
</ng-template>